module.exports = "/images/goOn.svg";